import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer, Badge } from '@mui/material'
import { useLayoutContext } from '../../../contexts/layout.context'
import aliveLogo from '../../../assets/alivelogo.png'
import { ALIVE_SUPPORT_URL, ERPDashboardPageURL, Icons } from '../../../utils/utilities'
import React, { useState } from 'react'

import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useUserStore } from '../../../store/user.store'

const getCodingLabsLink = () => {
    const prod = true
    const baseUrl = prod ? `https://codelabs.alive.university` : `http://localhost:5173`

    if ( sessionStorage.getItem( "impersonation_id_token" ) )
        return `${baseUrl}/sso?token=${sessionStorage.getItem( "impersonation_id_token" )}`
    return `${baseUrl}/sso?token=${localStorage.getItem( 'id_token' )}`
}

// { id: 10, activeMatchRegexes: [[/^(\/faculty\/quizes)\/?$/, /^(\/faculty\/auizes\/\d+)\/?$/], [/^(\/faculty\/quizes)\/?$/, /^(\/faculty\/quizes\/\d+\/participation)\/?$/, /^(\/faculty\/quizes\/\d+\/evaluate\/\d+)\/?$/]], permission: true, childrenPermissions: [true, true], label: "Quizes", children: ["My Quizes", "Quiz Instances"], childrenIcons: [{ default: Icons.default.QuestionMarkOutlined, activeIcon: Icons.default.QuestionMark }, { default: Icons.default.BadgeOutlined, activeIcon: Icons.default.Badge }], link: ["/faculty/quizes", "/faculty/quizes"], activeIcon: Icons.default.QuestionMark, icon: Icons.default.QuestionMarkOutlined },
// { id: 7, activeMatchRegexes: [/^(\/faculty\/attendance)\/?$/], permission: true, label: "Attendance", children: null, link: `/faculty/attendance`, icon: Icons.default.EmojiPeopleIconOutlined, activeIcon: Icons.default.EmojiPeopleIcon },
// { id: 8, activeMatchRegexes: [/^(\/faculty\/recordings)\/?$/], permission: true, label: "Recordings", children: null, link: `/faculty/recordings`, icon: Icons.default.VideocamIconOutlined, activeIcon: Icons.default.VideocamIcon },


// BETA TAG
// <small style={{ fontSize: "8px", background: "#eee3", padding: "3px", borderRadius: "5px" }}><b><i>BETA</i></b> </small> 

const allMenu = [
    { id: 'menuitem-home', view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/home)\/?$/], permission: true, label: "Home", children: null, link: `/faculty/home`, icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon },
    { id: 'menuitem-practice-with-simba', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/practice-with-simba)\/?$/, /^(\/faculty\/practice-with-simba)\/\w+\/?$/], permission: "simba_ai", label: "Practice Sessions with Simba", children: null, link: `/faculty/practice-with-simba`, icon: Icons.default.SubjectsOutlined, activeIcon: Icons.default.Subjects, new: true },
    { id: 'menuitem-materials', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/material)\/?$/, /^(\/faculty\/material\/\d+)\/?$/, /^(\/faculty\/material\/add)\/?$/], permission: true, label: "Study Materials", children: null, link: `/faculty/material`, icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon },
    { id: 'menuitem-class-resources', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/class-sessions)\/?$/, /^(\/faculty\/class-sessions\/\d+)\/?$/], permission: true, label: "Beyond Class Resources", children: null, link: `/faculty/class-sessions`, icon: Icons.default.ClassOutlined, activeIcon: Icons.default.Class },
    { id: 'menuitem-assignment', view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/assignment)\/?$/, /^(\/faculty\/assignment)\/\d+\/?$/], permission: true, label: "Assignments", children: null, link: `/faculty/assignment`, icon: Icons.default.AssignmentIconOutlined, activeIcon: Icons.default.AssignmentIcon },
    { id: 'menuitem-exams', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/exams)\/?$/, /^(\/faculty\/addexam)\/?$/, /^(\/faculty\/exams\/\d+)\/?$/, /^(\/faculty\/exams\/\d+\/questions)\/?$/, /^(\/faculty\/exams\/\d+\/addquestions)\/?$/, /^(\/faculty\/participations)\/?$/, /^(\/faculty\/exams\/\d+\/participation)\/?$/, /^(\/faculty\/exams\/\d+\/evaluate\/\d+)\/?$/], permission: true, label: "Exams", link: "/faculty/exams", children: null, activeIcon: Icons.default.QuizIcon, icon: Icons.default.QuizIconOutlined },
    { id: 'menuitem-quizzes', view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/quizzes)\/?$/, /^(\/faculty\/quizzes)\/\d+\/?$/], permission: true, label: "Quizzes", children: null, link: `/faculty/quizzes`, icon: Icons.default.PsychologyAltOutlined, activeIcon: Icons.default.PsychologyAlt },
    { id: 'menuitem-questionbanks', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/questionbank)\/?$/, /^(\/faculty\/questionbank)\/\d+\/?$/], permission: true, label: "Question Banks", children: null, link: `/faculty/questionbank`, icon: Icons.default.QuestionMarkOutlined, activeIcon: Icons.default.QuestionMark },
    { id: 'menuitem-codelabs', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], secondaryIcon: Icons.small.OpenInNewIcon, target: "_blank", label: "Coding labs", permission: true, children: null, link: getCodingLabsLink, activeIcon: Icons.default.CodeLab, icon: Icons.default.CodeLab },
    { id: 'menuitem-discussions', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/discussions)\/?$/, /^(\/faculty\/discussions\/\w+)\/?$/, /^(\/faculty\/discussion\/\w+)\/?$/, /^(\/faculty\/my-discussions)\/?$/, /^(\/faculty\/my-discussions\/\w+)\/?$/], permission: true, link: "/faculty/discussions", label: "Discussions", children: null, activeIcon: Icons.default.Discussions, icon: Icons.default.DiscussionsOutlined },
    { id: 'menuitem-online-classes', view: ["left-panel", "opened-bottom-bar"], headerText: "Online Classes", activeMatchRegexes: [/^(\/faculty\/online-classes)\/?$/, /^(\/faculty\/class\/[\w-]+)\/?$/], permission: true, label: "Online Classes", children: null, link: "/faculty/online-classes", activeIcon: Icons.default.OndemandVideoIconOutlined, icon: Icons.default.OndemandVideoIconOutlined },
    { id: 'menuitem-hybrid-classes', view: ["left-panel", "opened-bottom-bar"], headerText: "Hybrid Classes", activeMatchRegexes: [/^(\/faculty\/hybrid-classes)\/?$/, /^(\/faculty\/hybrid-class\/[\w-]+)\/?$/], permission: true, label: "Hybrid Classes", children: null, link: "/faculty/hybrid-classes", activeIcon: Icons.default.HybridClasses, icon: Icons.default.HybridClassesOutlined },
    { id: 'menuitem-meetings', view: ["left-panel", "opened-bottom-bar"], headerText: "Webinars and Meetings", activeMatchRegexes: [/^(\/faculty\/meetings)\/?$/, /^(\/faculty\/meeting\/[\w-]+)\/?$/, /^(\/faculty\/webinar\/[\w-]+)\/?$/], permission: true, label: "Webinars & Meetings", children: null, new: true, link: "/faculty/meetings", activeIcon: Icons.default.MeetingRooms, icon: Icons.default.MeetingRoomsOutlined },
    { id: 'menuitem-faq', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/tutorials-and-manuals)\/?$/], permission: true, label: "Quick Guides: Demos & Manuals", children: null, link: `/faculty/tutorials-and-manuals`, icon: Icons.default.LiveHelpIconOutlined, activeIcon: Icons.default.LiveHelpIcon },
    { id: 'menuitem-support', view: ["left-panel", "opened-bottom-bar"], secondaryIcon: Icons.small.OpenInNewIcon, activeMatchRegexes: [], target: "_blank", permission: true, label: "Support", children: null, link: ALIVE_SUPPORT_URL, icon: Icons.default.SupportAgentOutlined, activeIcon: Icons.default.SupportAgent },
    { id: 'menuitem-erp', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], permission: true, label: "ERP", children: null, link: ERPDashboardPageURL, icon: Icons.default.Logout, activeIcon: Icons.default.Logout },
]


const SidedrawerMenuItem = ( { item, isActive, sidebarOpenState, closeOnMobileScreen, active } ) => {

    const [collapseState, setCollapseState] = useState( false )
    const { palette } = useTheme()
    const { pathname, search } = useLocation()


    return <Box borderRadius="5px" bgcolor={collapseState && palette.nav.sidebarHover}>
        <Link className='default-link' target={item.target} id={item.id} to={!item.children ? typeof item.link === 'string' ? item.link : item.link() : pathname + search}>
            <Box
                onClick={item.children ? () => setCollapseState( !collapseState ) : closeOnMobileScreen}
                color={palette.nav.font}
                borderRadius="5px"
                sx={{
                    cursor: "pointer",
                    position: "relative",
                    background: collapseState ? isActive ? palette.nav.activeSidebarItem + "44" : "none" : isActive ? palette.nav.activeSidebarItem : "none",
                    "&:hover": {
                        background: !isActive ? palette.nav.activeSidebarItem + 80 : palette.nav.activeSidebarItem,
                    }
                }}
                display="flex"
                alignItems="center"
                padding="5px"
                gap="15px"
                marginY="5px"
            >
                <IconButton
                    color="inherit"
                    // size='small'
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    sx={{
                        padding: "2px",
                        borderRadius: "5px",
                        transform: "scale(0.9)",
                        position: "relative",
                        fontSize: "18px"
                    }}>
                    {isActive ? item.icon : item.icon}
                </IconButton>

                <Box flexGrow={1} gap="5px" justifyContent="space-between" display="flex" alignItems="center" flexShrink={0} color="inherit" fontWeight={isActive ? "500" : "300"} fontSize="14px" textAlign="center">
                    <Typography display="flex" gap="5px" alignItems="center" color="inherit" fontWeight={isActive ? "500" : "400"} fontSize="14px">
                        {item.label}
                        {item.new && <Typography component="span" sx={{ fontSize: "8px", background: `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, padding: "3px 3px", top: "12px", right: "-15px", borderRadius: "5px" }} >NEW</Typography>}
                    </Typography>
                    <Box component="span" color={palette.text.secondary}>{item.children ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ""}</Box>
                </Box>
            </Box>
        </Link>
        {item.children && <Collapse in={collapseState}>
            <Box
                flexDirection="column"
                paddingBottom="10px"
                display="flex"
                gap="5px"
                paddingRight="20px"
                paddingLeft="30px"
                sx={{
                    position: "relative",
                    "&::before": {
                        display: "inline-block",
                        content: "''",
                        position: "absolute",
                        background: palette.nav.font + "88",
                        height: "calc(100% - 20px )",
                        borderRadius: "0 2px 2px 0",
                        left: "15px",
                        width: "1px",
                        zIndex: 324434,
                        top: "0",
                    },
                }}
            >
                {item.children.map( ( sublink, index ) => {
                    const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                    return <Link className='default-link' key={sublink} to={item.link[index]}>
                        <Box
                            display="flex"
                            onClick={closeOnMobileScreen}
                            borderRadius="5px"
                            padding="2px 5px"
                            gap="20px"
                            alignItems="center"
                            bgcolor={activeChild ? palette.nav.activeSidebarItem : "none"}
                            sx={{
                                color: activeChild ? "white" : "lightgrey",
                                cursor: "pointer",
                                position: "relative",

                                // "&::before": {
                                //     display: activeChild ? "inline-block" : "none",
                                //     content: "''",
                                //     position: "absolute",
                                //     background: "#fff",
                                //     height: "60%",
                                //     borderRadius: "0 2px 2px 0",
                                //     left: 0,
                                //     width: "2px",
                                //     zIndex: 324434,
                                //     top: "50%",
                                //     transform: "translate(0,-50%)"
                                // },

                                "&:hover": {
                                    background: !activeChild ? palette.nav.activeSidebarItem + "aa" : palette.nav.activeSidebarItem,
                                }
                            }}
                        >
                            <Typography variant="subtitle2" flexShrink={0} color="inherit" fontWeight={activeChild ? "500" : "400"} fontSize="14px" textAlign="center">{sublink}</Typography>
                        </Box>
                    </Link>
                } )}
            </Box>
        </Collapse>}
    </Box>
}

const SideDrawer = function ( { closeSideMenu } ) {
    const { sidebarOpenState, setNavHeadText, active, setMenuState, menuState, sidebarWidth, minSidebarCollapseWidth } = useLayoutContext()

    const [menu] = useState( allMenu )

    const { palette } = useTheme()

    const UserStore = useUserStore()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            closeSideMenu()
    }

    useEffect( () => {
        for ( let i = 0; i < menu.length; i++ ) {
            const item = menu[i]
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.headerText ?? item.label )
                break
            }
        }
    }, [menu, active, setNavHeadText] )


    return (
        <Box>
            <Box display={{ sm: "block", xs: "none" }}>
                <Drawer
                    variant='persistent'
                    sx={{ background: "transparent", position: { sm: "static", xs: "fixed" }, zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, height: "100%", flexSrink: 0, display: "flex", flexDirection: "column" }}
                    anchor="left"
                    open={menuState}
                    className="no-scrollbar"
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { width: sidebarWidth, borderRadius: "0", background: palette.layoutBackground, borderRight: "none" } }
                    }}
                >
                    <Box position="relative" flexGrow={1} overflow="auto" display="flex">
                        <Box className="sidebar-scrollbar" display="flex" flexDirection="column" width="100%" overflow="auto" color="GrayText" alignItems="stretch">
                            <Box display="flex" gap="10px" padding="20px 10px" alignItems="center">
                                <Box padding="5px 7px" display="flex" alignItems="center" justifyContent="center" borderRadius="5px" sx={{ aspectRatio: "1 / 1" }} bgcolor="white"><Box component="img" width="20px" src={aliveLogo} alt="Logo" /></Box>
                                <Box>
                                    <Typography color="white" fontSize="14px" variant='h6'>Alive</Typography>
                                    <Typography color="white" fontSize="12px" fontWeight="300" variant='body2'>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: "white", display: { sm: "none", xs: "flex" } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box padding="0 10px 20px 10px" className="sidebar-scrollbar" flexGrow={1} overflow="auto">
                                {menu.map( item => {
                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                    let permission = false
                                    if ( typeof item.permission === 'boolean' )
                                        permission = item.permission
                                    else if ( typeof item.permission === 'string' )
                                        permission = UserStore.getUser?.features_permissions?.[item.permission] ?? false

                                    if ( permission )
                                        return <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    return null
                                } )}
                            </Box>
                        </Box>
                    </Box >
                </Drawer >
            </Box>

            {/* Bleeding Bottom Navigation Bar for devices with small screen */}
            <Box display={{ sm: "none", xs: "block" }}>
                <Box display="flex" gap="20px" alignItems="flex-end" sx={{ background: `linear-gradient(90deg, rgb(3, 0, 52) 25.54%, rgb(10, 0, 154) 205.66%)` }} justifyContent="space-evenly" padding="10px 20px">
                    {menu.filter( item => item.view.includes( "bleeding-bottom-bar" ) ).map( item => {
                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box color={isActive ? palette.nav.activeSidebarItem : "white"} display="flex" alignItems="center" flexDirection="column" gap="5px">
                                        <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{item.icon}</Box>
                                        <Typography color={isActive ? palette.nav.activeSidebarItem : "white"} fontSize="12px" variant='subtitle2' textAlign="center" >{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    <Box sx={{ cursor: "pointer" }} onClick={() => setMenuState( true )} color="white" display="flex" alignItems="center" flexDirection="column" gap="5px">
                        <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{Icons.default.Menu}</Box>
                        <Typography color="white" fontSize="12px" variant='subtitle2' textAlign="center" >More</Typography>
                    </Box>
                </Box>
                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexSrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: "10px 10px 0 0", background: `linear-gradient(90deg, rgb(3, 0, 52) 25.54%, rgb(10, 0, 154) 205.66%)`, borderRight: "none" } }
                    }}
                >
                    <Box position="relative" flexGrow={1} overflow="auto" display="flex">
                        <Box className="sidebar-scrollbar" display="grid" gridTemplateColumns="repeat(auto-fill,100px)" padding="40px 20px" flexWrap="wrap" width="100%" gap="30px" justifyContent="space-evenly" overflow="auto" color="GrayText" alignItems="stretch">
                            {menu.filter( item => item.view.includes( "opened-bottom-bar" ) ).map( item => {
                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                return (
                                    <Box key={item.id}>
                                        <Link to={typeof item.link === 'string' ? item.link : item.link()} onClick={() => setMenuState( false )} className='default-link' >
                                            <Box color={isActive ? palette.nav.activeSidebarItem : "white"} maxWidth="120px" display="flex" alignItems="center" flexDirection="column" gap="5px">
                                                <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{item.icon}</Box>
                                                <Typography color={isActive ? palette.nav.activeSidebarItem : "white"} fontSize="12px" textAlign="center" >{item.label}</Typography>
                                            </Box>
                                        </Link>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box >
                </SwipeableDrawer >
            </Box>
        </Box >
    )
}

export default SideDrawer


